<script setup lang="ts">
import type { SurveyQuestion } from '@/types/surveyTypes'

defineProps<{
  question: SurveyQuestion
}>()
</script>

<template>
  <div class="html-type-content" v-html="question.label" />
</template>

<style scoped>
.html-type-content :deep(a) {
  color: var(--primary-color);
}
</style>
